"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const OsmosysBaseEntity_1 = require("../OsmosysBaseEntity");
const Integration_1 = require("../integrations/Integration");
const auth_1 = require("../auth");
const Workspace_1 = require("../auth/Workspace");
let EmailBase = class EmailBase extends OsmosysBaseEntity_1.OsmosysBaseEntity {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => auth_1.User),
    typeorm_1.ManyToOne(() => auth_1.User, {
        cascade: true,
        nullable: true,
        onDelete: 'SET NULL',
    }),
    tslib_1.__metadata("design:type", Object)
], EmailBase.prototype, "creatingUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Workspace_1.Workspace),
    typeorm_1.ManyToOne(() => Workspace_1.Workspace),
    typeorm_1.JoinColumn(),
    tslib_1.__metadata("design:type", Object)
], EmailBase.prototype, "workspace", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailBase.prototype, "html", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Integration_1.Integration, { nullable: true }),
    typeorm_1.ManyToOne(() => Integration_1.Integration, {
        lazy: true,
        nullable: true,
    }),
    tslib_1.__metadata("design:type", Object)
], EmailBase.prototype, "emailServiceProvider", void 0);
tslib_1.__decorate([
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailBase.prototype, "subjectLine", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [String], { nullable: true }),
    typeorm_1.Column({
        nullable: true,
        type: 'simple-array',
    }),
    tslib_1.__metadata("design:type", Array)
], EmailBase.prototype, "subjectLines", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailBase.prototype, "fromName", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailBase.prototype, "fromEmail", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(),
    typeorm_1.Column({ default: '' }),
    tslib_1.__metadata("design:type", String)
], EmailBase.prototype, "replyToEmail", void 0);
EmailBase = tslib_1.__decorate([
    type_graphql_1.ObjectType()
], EmailBase);
exports.EmailBase = EmailBase;
class EmailBaseEntity extends EmailBase {
    toString() {
        return this.subjectLines && this.subjectLines[0]
            ? this.subjectLines[0]
            : `Email #${this.id}`;
    }
}
exports.EmailBaseEntity = EmailBaseEntity;
//# sourceMappingURL=EmailBase.js.map